import React from 'react';
import {
  Box,
  Button,
  Card,
  Skeleton,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const MessageCardSkeleton = () => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      gap={2}
      p={2}
      borderRadius={3}
      bgcolor={palette.action.hover}
    >
      <Skeleton kind="circular" width={40} height={40} />

      <Box flex={1}>
        <Skeleton kind="text" width="45%" height={30} />

        <Skeleton kind="text" width="30%" height={24} />

        <Skeleton kind="text" width="100%" height={34} />
      </Box>

      <Skeleton kind="circular" width={10} height={10} sx={{ mt: 1 }} />
    </Box>
  );
};

const MessagesWidget = () => {
  const { palette } = useTheme();
  const isLoading = true;

  return (
    <Card
      sx={{
        borderRadius: '0.75rem',
        padding: '1rem',
        boxShadow: 'none',
        border: `1px solid ${palette.divider}`,
        bgcolor: palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '600px',
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
        mt={-0.5}
      >
        <Box display="flex" alignItems="center" gap="10px">
          <Typography variant="subtitle1" fontWeight="medium" color="primary">
            Messages
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={2} flex={1}>
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <MessageCardSkeleton key={index} />
          ))
        ) : (
          <>messages</>
        )}
      </Box>

      <Button fullWidth kind="secondary" endIcon={<ArrowForwardIcon />}>
        View all messages
      </Button>
    </Card>
  );
};

export default MessagesWidget;
